import React from 'react';
import { Trophy, Medal } from 'lucide-react';
import { LeaderboardEntry } from '../data/mockData';
interface LeaderboardProps {
  leaderboard: LeaderboardEntry[];
}
export function Leaderboard({
  leaderboard
}: LeaderboardProps) {
  return <section className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-126">
      <div className="flex justify-between items-center mb-4" data-id="element-127">
        <h2 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-128">
          <span className="w-1.5 h-5 bg-amber-500 rounded-full" data-id="element-129"></span>
          Leaderboard
        </h2>
        <Trophy className="w-5 h-5 text-amber-400" data-id="element-130" />
      </div>

      <div className="overflow-x-auto overflow-y-auto flex-1 pr-2 -mr-2 custom-scrollbar" data-id="element-131">
        <table className="w-full text-left border-collapse min-w-[700px]" data-id="element-132">
          <thead data-id="element-133">
            <tr className="border-b border-slate-700/50 text-xs uppercase tracking-wider text-slate-400 sticky top-0 bg-slate-800/95 backdrop-blur-sm z-10" data-id="element-134">
              <th className="pb-3 font-medium w-12 text-center" data-id="element-135">Rank</th>
              <th className="pb-3 font-medium" data-id="element-136">Name</th>
              <th className="pb-3 font-medium text-right" data-id="element-137">Dials</th>
              <th className="pb-3 font-medium text-right" data-id="element-138">Convos</th>
              <th className="pb-3 font-medium text-right" data-id="element-139">Pulls</th>
              <th className="pb-3 font-medium text-right" data-id="element-140">Apps</th>
              <th className="pb-3 font-medium text-right" data-id="element-141">Subs</th>
              <th className="pb-3 font-medium text-right" data-id="element-142">Locks</th>
              <th className="pb-3 font-medium text-right" data-id="element-143">Score</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-700/30" data-id="element-144">
            {leaderboard.map(entry => <tr key={entry.name} className={`transition-colors ${entry.isCurrentUser ? 'bg-cyan-900/30 border-l-2 border-l-cyan-400' : 'hover:bg-slate-700/20'}`} data-id="element-145">
                <td className="py-2.5 text-center" data-id="element-146">
                  {entry.rank === 1 ? <Medal className="w-5 h-5 text-yellow-400 mx-auto" data-id="element-147" /> : entry.rank === 2 ? <Medal className="w-5 h-5 text-slate-300 mx-auto" data-id="element-148" /> : entry.rank === 3 ? <Medal className="w-5 h-5 text-amber-600 mx-auto" data-id="element-149" /> : <span className="text-sm font-medium text-slate-400" data-id="element-150">
                      {entry.rank}
                    </span>}
                </td>
                <td className="py-2.5" data-id="element-151">
                  <span className={`text-sm font-medium ${entry.isCurrentUser ? 'text-cyan-400' : 'text-slate-200'}`} data-id="element-152">
                    {entry.name} {entry.isCurrentUser && '(You)'}
                  </span>
                </td>
                <td className="py-2.5 text-sm text-slate-300 text-right font-mono" data-id="element-153">
                  {entry.dials}
                </td>
                <td className="py-2.5 text-sm text-slate-300 text-right font-mono" data-id="element-154">
                  {entry.conversations}
                </td>
                <td className="py-2.5 text-sm text-slate-300 text-right font-mono" data-id="element-155">
                  {entry.creditPulls}
                </td>
                <td className="py-2.5 text-sm text-slate-300 text-right font-mono" data-id="element-156">
                  {entry.applications}
                </td>
                <td className="py-2.5 text-sm text-slate-300 text-right font-mono" data-id="element-157">
                  {entry.submissions}
                </td>
                <td className="py-2.5 text-sm font-bold text-white text-right" data-id="element-158">
                  {entry.locks}
                </td>
                <td className="py-2.5 text-sm text-slate-400 text-right font-mono" data-id="element-159">
                  {entry.score}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>

      <style data-id="element-160">{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #334155;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #475569;
        }
      `}</style>
    </section>;
}